import React, { ComponentType, ReactElement } from 'react';
import { EditorPlugin } from '@draft-js-plugins/editor';
import { EditorState } from 'draft-js';

import EmojiMartDropdown, { EmojiMartDropdownPubProps } from './EmojiMartDropdown/EmojiMartDropdown';

export interface EmojiData {
  colons: string;
  emoticons: string[];
  id: string;
  name: string;
  native: string;
  short_names: string[];
  skin: number;
  unified: string;
}

export interface EmojiPluginStore {
  setEditorState?(editorState: EditorState): void;
  getEditorState?(): EditorState;
  getIsOpened(): boolean;
  setIsOpened(nextIsOpened: boolean): void;
}

export interface EmojiPluginConfig {
  emojiPrefix?: string;
}

export default (
  // config variables coming in next phase of emoji plugin
  // eslint-disable-next-line
  config: EmojiPluginConfig = {}
): EditorPlugin & {
  EmojiMartDropdown: ComponentType<EmojiMartDropdownPubProps>;
} => {
  let isDropdownOpen = false;

  const store: EmojiPluginStore = {
    getEditorState: undefined,
    setEditorState: undefined,

    getIsOpened: () => isDropdownOpen,
    setIsOpened: nextIsOpened => {
      isDropdownOpen = nextIsOpened;
    },
  };

  const DecoratedEmojiMartDropdown = (props: EmojiMartDropdownPubProps): ReactElement => (
    <EmojiMartDropdown {...props} store={store} />
  );
  return {
    EmojiMartDropdown: DecoratedEmojiMartDropdown,
    initialize: ({ getEditorState, setEditorState }) => {
      store.getEditorState = getEditorState;
      store.setEditorState = setEditorState;
    },
  };
};
